import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ModelType } from '@shared/constants/model-type.enum';
import { Observable } from 'rxjs';
import { IGeneralData } from '@models/general-data.model';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  private apiService = inject(ApiService);

  getGeneralData(projectId: number, modelType: ModelType): Observable<IGeneralData> {
    return this.apiService.get(`general/${projectId}`, modelType);
  }
}